import React from 'react'
import CompleteRegistration from '../section/auth/CompleteRegistration'

export default function CompleteAccount({}) {
  
  return(
    <CompleteRegistration />
  )
}
